import React, { useEffect, useState, useRef } from "react";
import { Pagination, PaginationItem, PaginationLink, Badge } from "reactstrap";

import { Button, Table } from "reactstrap";

import { getBlogs } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import useToastr from "helpers/toastr";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import ButtonLoader from "Component/Common/ButtonLoader";
import { useTranslation } from 'react-i18next';

const Blogs = () => {
  const itemsPerPage = 1;
  const navigate = useNavigate();
  const toastr = useToastr();

  const [showReadMore, setShowReadMore] = useState(false);
  const contentRef = useRef(null);;
  const { t } = useTranslation();

  const { blogs, totalBlogs, loading } = useSelector(({ Blogs }) => Blogs);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.Login);
  const lang = localStorage.getItem("lang")

  const [filter, setFilter] = useState({
    orderBy: "createdAt",
    order: -1,
    page: 1,
    pageSize: 10,
  });

  const [blogsList, setBlogList] = useState([]);

  useEffect(() => {
    dispatch(getBlogs({ ...filter }));
  }, [filter]);

  useEffect(() => {
    if (blogs?.length > 0) {
      setBlogList(blogs);
    }
  }, [blogs, lang]);




  const handleBack = () => {
    navigate(-1);
  };


  

  return (
    <React.Fragment>


      <section className="history_page home_banner_main sellpagetwo position-relative">
        <div className="top_circle"></div>
        <Container>
          <div className="d-flex align-items-center">
            <Link to="" onClick={handleBack} className="arrow_back me-3">
              <svg
                role="button"
                width="25"
                height="25"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="#000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M13 5H1m0 0 4 4M1 5l4-4"
                />
              </svg>
            </Link>

            <h4 className="text-start m-0">{t('blogs')}</h4>
          </div>

          <div className="history_table mt-4">
            {loading && <ButtonLoader />}
            <div className="blogWrpper">
              <Row>
                {
                  blogs.length > 0 && blogs.map((obj, index) => (
                    <Col lg="4" sm="6" className="my-2">
                      <div className="cardCstm h-100">
                        <div className="imgWrp">
                          <img src={obj?.blogImage?.link} alt="" className="img-fluid" />
                        </div>
                        <div className="content text-start pb-4 py-3 px-3">
                          <h4 className="m-0 head">{lang == "ar" ? obj?.titleAr : obj?.titleEn}</h4>
                          <div className="descp">
                            <p ref={contentRef} className=" my-2"> {lang == "ar" ? obj?.descriptionAr : obj?.descriptionEn}
                            </p>
                           

                              <Link to={"/view-blog/" + obj?.slug} className="themeClr fw-sbold">{t('read_more')}</Link>
                            
                          </div>

                        </div>
                      </div>

                    </Col>
                  ))
                }

              </Row>
              {!loading && blogsList.length === 0 && (
                <p>{t('no_blogs')}</p>
              )}
            </div>
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Blogs;
